if (!customElements.get('single-or-pair')) {
  customElements.define('single-or-pair', class SingleOrPair extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.product-form__submit[data-quantity]');

      this.buttons.forEach((elem) => {
        elem.addEventListener(
          'click',
          this.updateQuantity.bind(this)
        )
      });
    }

    updateQuantity(event) {
      const btn = event.currentTarget;

      btn.classList.add('clicked');

      event.target.closest('form').querySelector('input[name="quantity"]').value = btn.dataset.quantity;
    }
  });
}
